import { render, staticRenderFns } from "./SelectKnowledgeParameters.vue?vue&type=template&id=7772f6c1&scoped=true&"
import script from "./SelectKnowledgeParameters.vue?vue&type=script&lang=js&"
export * from "./SelectKnowledgeParameters.vue?vue&type=script&lang=js&"
import style0 from "./SelectKnowledgeParameters.vue?vue&type=style&index=0&id=7772f6c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772f6c1",
  null
  
)

export default component.exports